import React from 'react';
import NumberFormat from 'react-number-format';

export default function Numeric(props) {
  const {
    name,
    value,
    onChange,
    className,
    negative = true,
    decimalScale = '2',
    fixedDecimalScale = true,
    type = 'text',
    disabled = false,
    prefix = '',
    onBlur,
    defaultValue = '0.00',
    decimalSeparator = '.',
  } = props;
  const handleFocus = (event) => event.target.select();
  return (
    <NumberFormat
      thousandSeparator={true}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      type={type}
      name={name}
      value={value}
      prefix={prefix}
      defaultValue={defaultValue}
      allowNegative={negative}
      allowEmptyFormatting={false}
      className={className}
      style={{ textAlign: 'right' }}
      onFocus={handleFocus}
      disabled={disabled}
      isNumericString={true}
      onValueChange={(values) => {
        //console.log('Numeric.onValueChange', values);
        if (onChange) onChange(parseFloat(values.value));
      }}
      onBlur={(values) => {
        //console.log('Numeric.onBlur', values.target.value);
        //let ret = Number(values.target.value.toString().replace('$', ''));
        let ret = values.target.value;
        if (prefix)
          ret = values.target.value.toString().replace({ prefix }, '');
        if (onBlur) onBlur(ret);
      }}
    />
  );
}
// style={{ textAlign: 'right', borderColor: value < 0 ? 'red' : 'grey' }}
